define('util/cookie',[], function() {
    'use strict';

    return {
        
        set:function(name, value, days)
        {
            sExpires='';
            if(days>0) {
                var oDate=new Date();
                oDate.setTime(oDate.getTime() +(days *1000 *60 *60 *24));
                var sExpires=";expires="+oDate.toUTCString();
            }
            
            document.cookie=name+"="+value+sExpires+";path=/";
        },

        get:function(name)
        {
            name+"=";
            var ca=document.cookie.split(';');
            for(var i=0; i<ca.length; i++) {
                var c=ca[i];
                while(c.charAt(0)===' ') {
                    c=c.substring(1);
                }
                if(c.indexOf(name)===0) {
                    return c.substring(name.length +1, c.length);
                }
            }

            return null;
        }
    };
});
